<template>
  <no-auth v-if="!hasAuthorize.calculate"></no-auth>
  <select-type v-else-if="!type" @change:type="SET_TYPE"></select-type>
  <div class="container-fluid o-card" v-else>
    <h4 v-if="activeTab === 'input'">
      {{ type }} - {{ $t("navigation.ehouseDoubleCalculating") }}
    </h4>
    <hr v-if="activeTab === 'input'" />
    <div class="row">
      <div class="es-xs-12">
        <div v-if="activeTab === 'input'">
          <div class="row">
            <!-- Sol Kolon - Giriş Verileri -->
            <div class="es-xs-12 es-sm-4">
              <div class="u-margin-bottom-small">
                <h6 class="u-margin-bottom-xsmall">
                  A. {{ $t("ehouseDoubleCalculating.ambientConditions") }}
                </h6>

                <BaseInput
                  v-model="form.altitudeLocation"
                  :label="
                    '1. ' + $t('ehouseDoubleCalculating.altitudeLocation')
                  "
                  block
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="0.0001"
                  :mandotary="validationActive"
                  suffix="meter"
                  type="number"
                  :min="0"
                  :placeholder="$t('ehouseDoubleCalculating.altitudeLocation')"
                ></BaseInput>

                <BaseInput
                  v-model="form.ambientPressure"
                  :label="'2. ' + $t('ehouseDoubleCalculating.ambientPressure')"
                  block
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="0.0001"
                  :mandotary="validationActive"
                  suffix="kPa"
                  type="number"
                  :min="0"
                  :placeholder="$t('ehouseDoubleCalculating.ambientPressure')"
                ></BaseInput>

                <BaseInput
                  v-model="form.ambientTemperature"
                  :label="
                    '3. ' + $t('ehouseDoubleCalculating.ambientTemperature')
                  "
                  block
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="0.0001"
                  :mandotary="validationActive"
                  suffix="°C"
                  type="number"
                  :min="0"
                  :placeholder="
                    $t('ehouseDoubleCalculating.ambientTemperature')
                  "
                ></BaseInput>

                <BaseInput
                  v-model="form.ambientRelativeHumidity"
                  block
                  :label="
                    '4. ' +
                    $t('ehouseDoubleCalculating.ambientRelativeHumidity')
                  "
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="0.0001"
                  :mandotary="validationActive"
                  suffix="%"
                  type="number"
                  :min="0"
                  :placeholder="
                    $t('ehouseDoubleCalculating.ambientRelativeHumidity')
                  "
                ></BaseInput>
                <BaseInput
                  v-model="form.solarRaditionPowerSquareMeter"
                  block
                  :label="'5. ' + $t('ehouseDoubleCalculating.radiationPower')"
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="0.0001"
                  :mandotary="validationActive"
                  suffix="W/m²"
                  type="number"
                  :min="0"
                  :placeholder="$t('ehouseDoubleCalculating.radiationPower')"
                ></BaseInput>
              </div>

              <div
                class="u-margin-bottom-small u-background-color-filtered o-card__padding-small"
              >
                <h6 class="u-margin-bottom-xsmall">
                  B. {{ $t("ehouseDoubleCalculating.geometricParameters") }}
                </h6>
                <p class="u-margin-bottom-xxsmall">
                  {{ $t("ehouseDoubleCalculating.mainRoom") }}
                </p>

                <BaseInput
                  v-model="form.length"
                  :label="'1. ' + $t('ehouseDoubleCalculating.length')"
                  block
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="0.0001"
                  :mandotary="validationActive"
                  suffix="mm"
                  type="number"
                  :min="0"
                  :placeholder="$t('ehouseDoubleCalculating.length')"
                ></BaseInput>
                <BaseInput
                  v-model="form.width"
                  block
                  :label="'2. ' + $t('ehouseDoubleCalculating.width')"
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="0.0001"
                  :mandotary="validationActive"
                  suffix="mm"
                  type="number"
                  :min="0"
                  :placeholder="$t('ehouseDoubleCalculating.width')"
                ></BaseInput>

                <BaseInput
                  v-model="form.heigth"
                  block
                  :label="'3. ' + $t('ehouseDoubleCalculating.height')"
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="0.0001"
                  :mandotary="validationActive"
                  suffix="mm"
                  type="number"
                  :min="0"
                  :placeholder="$t('ehouseDoubleCalculating.height')"
                ></BaseInput>

                <BaseInput
                  v-model="form.numberOfDoors"
                  :label="'4. ' + $t('ehouseDoubleCalculating.numberOfDoors')"
                  block
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="1"
                  :suffix="$t('common.pcs')"
                  type="number"
                  :min="0"
                  :placeholder="$t('ehouseDoubleCalculating.numberOfDoors')"
                ></BaseInput>

                <BaseInput
                  v-model="form.numberOfElectricalInletOutlet"
                  :label="
                    '5. ' + $t('ehouseDoubleCalculating.electricalInletOutlet')
                  "
                  block
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="1"
                  :suffix="$t('common.pcs')"
                  type="number"
                  :min="0"
                  :placeholder="
                    $t('ehouseDoubleCalculating.electricalInletOutlet')
                  "
                ></BaseInput>

                <p class="u-margin-top-small u-margin-bottom-xxsmall">
                  {{ $t("ehouseDoubleCalculating.auxiliaryRoom") }}
                </p>

                <BaseInput
                  v-model="form.lengthAuxiliary"
                  :label="'1. ' + $t('ehouseDoubleCalculating.length')"
                  block
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="0.0001"
                  :mandotary="validationActive"
                  suffix="mm"
                  type="number"
                  :min="0"
                  :placeholder="$t('ehouseDoubleCalculating.length')"
                ></BaseInput>

                <BaseInput
                  v-model="form.widthAuxiliary"
                  :label="'2. ' + $t('ehouseDoubleCalculating.width')"
                  block
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="0.0001"
                  :mandotary="validationActive"
                  suffix="mm"
                  type="number"
                  :min="0"
                  :placeholder="$t('ehouseDoubleCalculating.width')"
                ></BaseInput>

                <BaseInput
                  v-model="form.heigthAuxiliary"
                  :label="'3. ' + $t('ehouseDoubleCalculating.height')"
                  block
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="0.0001"
                  :mandotary="validationActive"
                  suffix="mm"
                  type="number"
                  :min="0"
                  :placeholder="$t('ehouseDoubleCalculating.height')"
                ></BaseInput>

                <div
                  class="u-display-flex u-align-items-center u-margin-xxsmall"
                >
                  <BaseInput
                    v-model="form.adjecentWallLength"
                    :label="'4. ' + $t('ehouseDoubleCalculating.adjecentWall')"
                    block
                    class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                    :size="creatingPdf ? 'sm' : 'xs'"
                    step="0.0001"
                    :mandotary="validationActive"
                    suffix="mm"
                    type="number"
                    :min="0"
                    :placeholder="$t('ehouseDoubleCalculating.adjecentWall')"
                  ></BaseInput>
                  <BaseInput
                    v-model="form.adjecentWallHeigth"
                    class="u-margin-left-xsmall u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                    :size="creatingPdf ? 'sm' : 'xs'"
                    step="0.0001"
                    :mandotary="validationActive"
                    :label="$t('ehouseDoubleCalculating.height')"
                    suffix="mm"
                    type="number"
                    :min="0"
                    placeholder="3000"
                  ></BaseInput>
                </div>
              </div>

              <div class="u-margin-bottom-small">
                <h6 class="u-margin-bottom-xsmall">
                  {{ $t("ehouseDoubleCalculating.mainRoomAirConditions") }}
                </h6>
                <BaseInput
                  v-model="form.airTemperature"
                  :label="'1. ' + $t('ehouseDoubleCalculating.airTemperature')"
                  block
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="0.0001"
                  :mandotary="validationActive"
                  suffix="°C"
                  type="number"
                  :min="0"
                  :placeholder="$t('ehouseDoubleCalculating.airTemperature')"
                ></BaseInput>

                <BaseInput
                  :label="
                    '2. ' + $t('ehouseDoubleCalculating.airRelativeHumidity')
                  "
                  block
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="0.0001"
                  :mandotary="validationActive"
                  v-model="form.airRelativeHumidity"
                  suffix="%"
                  type="number"
                  :min="0"
                  :placeholder="
                    $t('ehouseDoubleCalculating.airRelativeHumidity')
                  "
                ></BaseInput>

                <BaseInput
                  :label="'2. ' + $t('ehouseDoubleCalculating.heatGeneration')"
                  block
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="0.0001"
                  :mandotary="validationActive"
                  v-model="form.heatGeneration"
                  suffix="kW"
                  type="number"
                  :min="0"
                  :placeholder="$t('ehouseDoubleCalculating.heatGeneration')"
                ></BaseInput>
              </div>

              <div class="u-margin-bottom-small">
                <h6 class="u-margin-bottom-xsmall">
                  {{ $t("ehouseDoubleCalculating.auxiliaryRoomAirConditions") }}
                </h6>

                <BaseInput
                  v-model="form.coolledAirRatio"
                  :label="$t('ehouseDoubleCalculating.coolledAirRatio')"
                  block
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="0.0001"
                  :mandotary="validationActive"
                  suffix="%"
                  type="number"
                  :min="0"
                  :placeholder="$t('ehouseDoubleCalculating.coolledAirRatio')"
                ></BaseInput>

                <BaseInput
                  v-model="form.auxiliaryHeatGeneration"
                  :label="$t('ehouseDoubleCalculating.heatGeneration')"
                  block
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="0.0001"
                  :mandotary="validationActive"
                  suffix="kW"
                  type="number"
                  :min="0"
                  :placeholder="$t('ehouseDoubleCalculating.heatGeneration')"
                ></BaseInput>

                <BaseInput
                  v-model="form.requiredPressurazing"
                  :label="$t('ehouseDoubleCalculating.requiredPressurization')"
                  block
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="0.0001"
                  :mandotary="validationActive"
                  suffix="Pa"
                  type="number"
                  :min="0"
                  :placeholder="
                    $t('ehouseDoubleCalculating.requiredPressurization')
                  "
                ></BaseInput>

                <BaseInput
                  v-model="form.pressurazingPressure"
                  :label="
                    $t('ehouseDoubleCalculating.requiredPressurizationStandard')
                  "
                  block
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="0.0001"
                  :mandotary="validationActive"
                  suffix="Pa"
                  type="number"
                  :min="0"
                  :placeholder="
                    $t('ehouseDoubleCalculating.requiredPressurizationStandard')
                  "
                  readonly
                ></BaseInput>
              </div>
            </div>

            <!-- Orta Kolon - Duvarlar ve Tavan -->
            <div class="es-xs-12 es-sm-4">
              <div class="u-margin-bottom-small">
                <h6 class="u-margin-bottom-xsmall">
                  {{ $t("ehouseDoubleCalculating.walls") }}
                </h6>

                <BaseInput
                  v-model="form.overallHeatTransferCoefficientU"
                  block
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  :label="
                    $t('ehouseDoubleCalculating.overallHeatTransferCoefficient')
                  "
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="0.0001"
                  :mandotary="validationActive"
                  suffix="W/m²K"
                  type="number"
                  :min="0"
                  :placeholder="
                    $t('ehouseDoubleCalculating.overallHeatTransferCoefficient')
                  "
                ></BaseInput>

                <div class="u-margin-top-small">
                  <div class="row">
                    <div class="es-xs-7">
                      <p>
                        <small>{{
                          $t("ehouseDoubleCalculating.material")
                        }}</small>
                      </p>
                    </div>
                    <div class="es-xs-3">
                      <p>
                        <small
                          >{{
                            $t("ehouseDoubleCalculating.thickness")
                          }}
                          [mm]</small
                        >
                      </p>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <small class="u-font-size-xsmall">k[W/mK]</small>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <p>
                        <small>{{
                          $t("ehouseDoubleCalculating.innerSideHeatConvection")
                        }}</small>
                      </p>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        :value="0"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="8"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <GetMetallicMaterials
                        class="u-display-flex u-align-items-center u-margin-0 u-flex-1-with-child c-form-control__variant--xs"
                        v-model="form.wallsMaterialValues1"
                        :label="
                          $t('ehouseDoubleCalculating.wallMaterialValues1')
                        "
                      ></GetMetallicMaterials>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        v-model="form.wallsThickness1"
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                        placeholder="2"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="form.wallsMaterialValues1.value"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <GetInsulationMaterials
                        v-model="form.wallsMaterialValues2"
                        class="u-display-flex u-align-items-center u-margin-0 u-flex-1-with-child c-form-control__variant--xs"
                        :label="
                          $t('ehouseDoubleCalculating.wallMaterialValues2')
                        "
                      ></GetInsulationMaterials>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        v-model="form.wallsThickness2"
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                        placeholder="80"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="form.wallsMaterialValues2.value"
                        readonly
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <GetBuildingMaterials
                        class="u-display-flex u-align-items-center u-margin-0 u-flex-1-with-child c-form-control__variant--xs"
                        v-model="form.wallsMaterialValues3"
                        :label="
                          $t('ehouseDoubleCalculating.wallMaterialValues3')
                        "
                      ></GetBuildingMaterials>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        v-model="form.wallsThickness3"
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                        placeholder="0"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="form.wallsMaterialValues3.value"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <GetBuildingMaterials
                        class="u-display-flex u-align-items-center u-margin-0 u-flex-1-with-child c-form-control__variant--xs"
                        v-model="form.wallsMaterialValues4"
                        :label="
                          $t('ehouseDoubleCalculating.wallMaterialValues4')
                        "
                      ></GetBuildingMaterials>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        v-model="form.wallsThickness4"
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                        placeholder="0"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="form.wallsMaterialValues4.value"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <GetMetallicMaterials
                        class="u-display-flex u-align-items-center u-margin-0 u-flex-1-with-child c-form-control__variant--xs"
                        v-model="form.wallsMaterialValues5"
                        :label="
                          $t('ehouseDoubleCalculating.wallMaterialValues5')
                        "
                      ></GetMetallicMaterials>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        v-model="form.wallsThickness5"
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                        placeholder="2"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="form.wallsMaterialValues5.value"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <p>
                        <small>{{
                          $t("ehouseDoubleCalculating.outerSideHeatConvection")
                        }}</small>
                      </p>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        :value="0"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="23"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="u-margin-bottom-small u-background-color-filtered o-card__padding-small"
              >
                <h6 class="u-margin-bottom-xsmall">
                  {{ $t("ehouseDoubleCalculating.ceiling") }}
                </h6>

                <BaseInput
                  v-model="form.ceilingOverallHeatTransferCoefficientU"
                  block
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  :label="
                    $t('ehouseDoubleCalculating.overallHeatTransferCoefficient')
                  "
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="0.0001"
                  :mandotary="validationActive"
                  suffix="W/m²K"
                  type="number"
                  :min="0"
                  :placeholder="
                    $t('ehouseDoubleCalculating.overallHeatTransferCoefficient')
                  "
                ></BaseInput>

                <div class="u-margin-top-small">
                  <div class="row">
                    <div class="es-xs-7">
                      <p>
                        <small>{{
                          $t("ehouseDoubleCalculating.material")
                        }}</small>
                      </p>
                    </div>
                    <div class="es-xs-3">
                      <p>
                        <small
                          >{{
                            $t("ehouseDoubleCalculating.thickness")
                          }}
                          [mm]</small
                        >
                      </p>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <p><small>k [W/mK]</small></p>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <p>
                        <small>{{
                          $t("ehouseDoubleCalculating.innerSideHeatConvection")
                        }}</small>
                      </p>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        :value="0"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="8"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <GetMetallicMaterials
                        class="u-display-flex u-align-items-center u-margin-0 u-flex-1-with-child c-form-control__variant--xs"
                        v-model="form.ceilingMaterialValues1"
                        :label="
                          $t('ehouseDoubleCalculating.wallMaterialValues1')
                        "
                      ></GetMetallicMaterials>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        v-model="form.ceilingThickness1"
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                        placeholder="2"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="form.ceilingMaterialValues1.value"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <GetInsulationMaterials
                        v-model="form.ceilingMaterialValues2"
                        class="u-display-flex u-align-items-center u-margin-0 u-flex-1-with-child c-form-control__variant--xs"
                        :label="
                          $t('ehouseDoubleCalculating.wallMaterialValues2')
                        "
                      ></GetInsulationMaterials>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        v-model="form.ceilingThickness2"
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                        placeholder="80"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="form.ceilingMaterialValues2.value"
                        readonly
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <GetBuildingMaterials
                        class="u-display-flex u-align-items-center u-margin-0 u-flex-1-with-child c-form-control__variant--xs"
                        v-model="form.ceilingMaterialValues3"
                        :label="
                          $t('ehouseDoubleCalculating.wallMaterialValues3')
                        "
                      ></GetBuildingMaterials>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        v-model="form.ceilingThickness3"
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                        placeholder="0"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="form.ceilingMaterialValues3.value"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <GetBuildingMaterials
                        class="u-display-flex u-align-items-center u-margin-0 u-flex-1-with-child c-form-control__variant--xs"
                        v-model="form.ceilingMaterialValues4"
                        :label="
                          $t('ehouseDoubleCalculating.wallMaterialValues4')
                        "
                      ></GetBuildingMaterials>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        v-model="form.ceilingThickness4"
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                        placeholder="0"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="form.ceilingMaterialValues4.value"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <GetMetallicMaterials
                        class="u-display-flex u-align-items-center u-margin-0 u-flex-1-with-child c-form-control__variant--xs"
                        v-model="form.ceilingMaterialValues5"
                        :label="
                          $t('ehouseDoubleCalculating.wallMaterialValues5')
                        "
                      ></GetMetallicMaterials>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        v-model="form.ceilingThickness5"
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                        placeholder="2"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="form.ceilingMaterialValues5.value"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <p>
                        <small>{{
                          $t("ehouseDoubleCalculating.outerSideHeatConvection")
                        }}</small>
                      </p>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        :value="0"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="23"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Sağ Kolon - Sonuçlar -->
            <div class="es-xs-12 es-sm-4">
              <div
                class="u-margin-bottom-small u-background-color-filtered o-card__padding-small"
              >
                <h6 class="u-margin-bottom-xsmall">
                  {{ $t("ehouseDoubleCalculating.floor") }}
                </h6>

                <BaseInput
                  v-model="form.floorF28"
                  :label="$t('ehouseDoubleCalculating.floorType')"
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  block
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="0.0001"
                  :mandotary="validationActive"
                  type="number"
                  :min="0"
                  :placeholder="$t('ehouseDoubleCalculating.floorType')"
                ></BaseInput>

                <BaseInput
                  v-model="form.floorOverallHeatTransferCoefficientU"
                  :label="
                    $t('ehouseDoubleCalculating.overallHeatTransferCoefficient')
                  "
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  block
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="0.0001"
                  :mandotary="validationActive"
                  suffix="W/m²K"
                  type="number"
                  :min="0"
                  :placeholder="
                    $t('ehouseDoubleCalculating.overallHeatTransferCoefficient')
                  "
                ></BaseInput>

                <div class="u-margin-top-small">
                  <div class="row">
                    <div class="es-xs-7">
                      <p>
                        <small>{{
                          $t("ehouseDoubleCalculating.material")
                        }}</small>
                      </p>
                    </div>
                    <div class="es-xs-3">
                      <p>
                        <small
                          >{{
                            $t("ehouseDoubleCalculating.thickness")
                          }}
                          [mm]</small
                        >
                      </p>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <p><small>k[W/mK]</small></p>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <p>
                        <small>{{
                          $t("ehouseDoubleCalculating.innerSideHeatConvection")
                        }}</small>
                      </p>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        :value="0"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="8"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <GetMetallicMaterials
                        class="u-display-flex u-align-items-center u-margin-0 u-flex-1-with-child c-form-control__variant--xs"
                        v-model="form.floorMaterialValues1"
                        :label="
                          $t('ehouseDoubleCalculating.wallMaterialValues1')
                        "
                      ></GetMetallicMaterials>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        v-model="form.floorThickness1"
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                        placeholder="2"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="form.floorMaterialValues1.value"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <GetInsulationMaterials
                        v-model="form.floorMaterialValues2"
                        class="u-display-flex u-align-items-center u-margin-0 u-flex-1-with-child c-form-control__variant--xs"
                        :label="
                          $t('ehouseDoubleCalculating.wallMaterialValues2')
                        "
                      ></GetInsulationMaterials>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        v-model="form.floorThickness2"
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                        placeholder="80"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="form.floorMaterialValues2.value"
                        readonly
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <GetBuildingMaterials
                        class="u-display-flex u-align-items-center u-margin-0 u-flex-1-with-child c-form-control__variant--xs"
                        v-model="form.floorMaterialValues3"
                        :label="
                          $t('ehouseDoubleCalculating.wallMaterialValues3')
                        "
                      ></GetBuildingMaterials>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        v-model="form.floorThickness3"
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                        placeholder="0"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="form.floorMaterialValues3.value"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <GetBuildingMaterials
                        class="u-display-flex u-align-items-center u-margin-0 u-flex-1-with-child c-form-control__variant--xs"
                        v-model="form.floorMaterialValues4"
                        :label="
                          $t('ehouseDoubleCalculating.wallMaterialValues4')
                        "
                      ></GetBuildingMaterials>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        v-model="form.floorThickness4"
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                        placeholder="0"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="form.floorMaterialValues4.value"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <GetMetallicMaterials
                        class="u-display-flex u-align-items-center u-margin-0 u-flex-1-with-child c-form-control__variant--xs"
                        v-model="form.floorMaterialValues5"
                        :label="
                          $t('ehouseDoubleCalculating.wallMaterialValues5')
                        "
                      ></GetMetallicMaterials>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        v-model="form.floorThickness5"
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                        placeholder="2"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="form.floorMaterialValues5.value"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <p>
                        <small>{{
                          $t("ehouseDoubleCalculating.outerSideHeatConvection")
                        }}</small>
                      </p>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        :value="0"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="23"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="type !== 'C1'" class="u-margin-bottom-small">
                <h6 class="u-margin-bottom-xsmall">
                  {{ $t("ehouseDoubleCalculating.adjacentWallMaterialValues") }}
                </h6>

                <BaseInput
                  v-model="form.adjacentWallOverallHeatTransferCoefficientU"
                  :label="
                    $t('ehouseDoubleCalculating.overallHeatTransferCoefficient')
                  "
                  class="u-display-flex u-align-items-center u-justify-content-space-between u-margin-xxsmall u-flex-1-with-child"
                  block
                  :size="creatingPdf ? 'sm' : 'xs'"
                  step="0.0001"
                  :mandotary="validationActive"
                  suffix="W/m²K"
                  type="number"
                  :min="0"
                  :placeholder="
                    $t('ehouseDoubleCalculating.overallHeatTransferCoefficient')
                  "
                ></BaseInput>

                <div class="u-margin-top-small">
                  <div class="row">
                    <div class="es-xs-7">
                      <p>
                        <small>{{
                          $t("ehouseDoubleCalculating.material")
                        }}</small>
                      </p>
                    </div>
                    <div class="es-xs-3">
                      <p>
                        <small
                          >{{
                            $t("ehouseDoubleCalculating.thickness")
                          }}
                          [mm]</small
                        >
                      </p>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <p><small>k[W/mK]</small></p>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <p>
                        <small>{{
                          $t("ehouseDoubleCalculating.innerSideHeatConvection")
                        }}</small>
                      </p>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        :value="0"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="8"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <GetMetallicMaterials
                        class="u-display-flex u-align-items-center u-margin-0 u-flex-1-with-child c-form-control__variant--xs"
                        v-model="form.adjacentWallMaterialValues1"
                        :label="
                          $t('ehouseDoubleCalculating.wallMaterialValues1')
                        "
                      ></GetMetallicMaterials>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        v-model="form.adjacentWallThickness1"
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                        placeholder="2"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="form.adjacentWallMaterialValues1.value"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <GetInsulationMaterials
                        v-model="form.adjacentWallMaterialValues2"
                        class="u-display-flex u-align-items-center u-margin-0 u-flex-1-with-child c-form-control__variant--xs"
                        :label="
                          $t('ehouseDoubleCalculating.insulationMaterial')
                        "
                      ></GetInsulationMaterials>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        v-model="form.adjacentWallThickness2"
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                        placeholder="80"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="form.adjacentWallMaterialValues2.value"
                        readonly
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <GetBuildingMaterials
                        class="u-display-flex u-align-items-center u-margin-0 u-flex-1-with-child c-form-control__variant--xs"
                        v-model="form.adjacentWallMaterialValues3"
                        :label="
                          $t('ehouseDoubleCalculating.wallMaterialValues3')
                        "
                      ></GetBuildingMaterials>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        v-model="form.adjacentWallThickness3"
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                        placeholder="0"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="form.adjacentWallMaterialValues3.value"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <GetBuildingMaterials
                        class="u-display-flex u-align-items-center u-margin-0 u-flex-1-with-child c-form-control__variant--xs"
                        v-model="form.adjacentWallMaterialValues4"
                        :label="
                          $t('ehouseDoubleCalculating.wallMaterialValues4')
                        "
                      ></GetBuildingMaterials>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        v-model="form.adjacentWallThickness4"
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                        placeholder="0"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="form.adjacentWallMaterialValues4.value"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <GetMetallicMaterials
                        class="u-display-flex u-align-items-center u-margin-0 u-flex-1-with-child c-form-control__variant--xs"
                        v-model="form.adjacentWallMaterialValues5"
                        :label="
                          $t('ehouseDoubleCalculating.wallMaterialValues5')
                        "
                      ></GetMetallicMaterials>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        v-model="form.adjacentWallThickness5"
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                        placeholder="2"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="form.adjacentWallMaterialValues5.value"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>

                  <div class="row">
                    <div class="es-xs-7">
                      <p>
                        <small>{{
                          $t("ehouseDoubleCalculating.outerSideHeatConvection")
                        }}</small>
                      </p>
                    </div>
                    <div class="es-xs-3">
                      <BaseInput
                        :value="0"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                    <div class="es-xs-2 u-padding-0">
                      <BaseInput
                        :value="23"
                        readonly
                        disabled
                        class="u-margin-0"
                        block
                        size="xs"
                        step="0.0001"
                        :mandotary="validationActive"
                      ></BaseInput>
                    </div>
                  </div>
                </div>
              </div>

              <Button
                block
                variant="warning"
                @click="calculate"
                class="u-margin-top-small u-margin-bottom-small"
              >
                {{ $t("ehouseDoubleCalculating.calculate") }}
              </Button>
            </div>
          </div>
        </div>

        <div v-if="activeTab === 'report'">
          <!-- Rapor içeriği burada olacak -->
          <Result
            :form="{ title: type, ...form }"
            :result="result"
            @reCalculate="activeTab = 'input'"
            :type="type"
            @save="save"
          />
        </div>
      </div>
    </div>
    <Detail
      v-if="creatingPdf"
      :title="title"
      :form="form"
      :result="result"
      auto-print
      @pdfCreated="creatingPdf = false"
    ></Detail>
  </div>
</template>

<script>
import BaseInput from "@/components/Base/Inputs/BaseInput.vue";
import Button from "@/components/Base/Button.vue";
//import Requests from "@/services/Requests";
import Detail from "./Detail.vue";
import GetBuildingMaterials from "./Searches/GetBuildingMaterials.vue";
import GetInsulationMaterials from "./Searches/GetInsulationMaterials.vue";
import GetMetallicMaterials from "./Searches/GetMetallicMaterials.vue";
import authorize from "./authorize";
import Requests from "@/services/Requests";
import Result from "./Result.vue";
import SelectType from "./SelectType.vue";

export default {
  mixins: [authorize],
  components: {
    BaseInput,
    Button,
    Detail,
    GetBuildingMaterials,
    GetInsulationMaterials,
    GetMetallicMaterials,
    Result,
    SelectType,
  },
  data() {
    return {
      title: "",
      creatingPdf: false,
      activeTab: "input",
      validationActive: false,
      form: {
        altitudeLocation: 250,
        ambientPressure: 100,
        ambientTemperature: 40,
        ambientRelativeHumidity: 65,
        solarRaditionPowerSquareMeter: 646,
        length: 15000,
        width: 9300,
        heigth: 3000,
        numberOfDoors: 2,
        numberOfElectricalInletOutlet: 2,
        lengthAuxiliary: 15000,
        widthAuxiliary: 2625,
        heigthAuxiliary: 3000,
        adjecentWallLength: 15000,
        adjecentWallHeigth: 3000,
        overallHeatTransferCoefficientU: 0,
        airTemperature: 22,
        airRelativeHumidity: 50,
        heatGeneration: 40.146,
        coolledAirRatio: 2.0,
        auxiliaryHeatGeneration: 1,
        requiredPressurazing: 20,
        pressurazingPressure: 4,
        wallsThickness1: 2,
        wallsThickness2: 80,
        wallsThickness3: 0,
        wallsThickness4: 0,
        wallsThickness5: 2,
        wallsMaterialValues1: {
          key: "Steel Plate",
          value: 54,
        },
        wallsMaterialValues2: {
          key: "Glasswool",
          value: 0.038,
        },
        wallsMaterialValues3: {
          key: "None",
          value: 1,
        },
        wallsMaterialValues4: {
          key: "None",
          value: 1,
        },
        wallsMaterialValues5: {
          key: "Steel Plate",
          value: 54,
        },
        floorF28: 1,
        floorOverallHeatTransferCoefficientU: 0,
        floorThickness1: 2,
        floorThickness2: 80,
        floorThickness3: 0,
        floorThickness4: 0,
        floorThickness5: 2,
        floorMaterialValues1: {
          key: "Steel Plate",
          value: 54,
        },
        floorMaterialValues2: {
          key: "Glasswool",
          value: 0.038,
        },
        floorMaterialValues3: {
          key: "None",
          value: 1,
        },
        floorMaterialValues4: {
          key: "None",
          value: 1,
        },
        floorMaterialValues5: {
          key: "Steel Plate",
          value: 54,
        },
        ceilingOverallHeatTransferCoefficientU: 0,
        ceilingThickness1: 2,
        ceilingThickness2: 80,
        ceilingThickness3: 0,
        ceilingThickness4: 0,
        ceilingThickness5: 2,
        ceilingMaterialValues1: {
          key: "Steel Plate",
          value: 54,
        },
        ceilingMaterialValues2: {
          key: "Glasswool",
          value: 0.038,
        },
        ceilingMaterialValues3: {
          key: "None",
          value: 1,
        },
        ceilingMaterialValues4: {
          key: "None",
          value: 1,
        },
        ceilingMaterialValues5: {
          key: "Steel Plate",
          value: 54,
        },
        adjacentWallOverallHeatTransferCoefficientU: 0,
        adjacentWallThickness1: 2,
        adjacentWallThickness2: 80,
        adjacentWallThickness3: 0,
        adjacentWallThickness4: 0,
        adjacentWallThickness5: 2,
        adjacentWallMaterialValues1: {
          key: "Steel Plate",
          value: 54,
        },
        adjacentWallMaterialValues2: {
          key: "Glasswool",
          value: 0.038,
        },
        adjacentWallMaterialValues3: {
          key: "None",
          value: 1,
        },
        adjacentWallMaterialValues4: {
          key: "None",
          value: 1,
        },
        adjacentWallMaterialValues5: {
          key: "Steel Plate",
          value: 54,
        },
        pvcThermalConductivity: {
          key: "PVC",
          value: 0.23,
        },
        noneMaterialThermalConductivity: {
          key: "None",
          value: 1,
        },
        steelPlateThermalConductivity: {
          key: "Steel Plate",
          value: 54,
        },
        asbestosThermalConductivity: {
          key: "Glasswool",
          value: 0.038,
        },
      },
      result: {
        status: false,
        calculatedE3: 0,
        averageWallHeatTransferCoefficient: 0,
        groundHeatTransferCoefficient: 0,
        ceilingHeatTransferCoefficient: 0,
        adjacentWallHeatTransferCoefficient: 0,
        roomHeatGainWithoutSolar: 0,
        mainRoomSolarHeatGain: 0,
        mainRoomHeatGeneration: 0,
        auxiliaryRoomHeatGainWithoutSolar: 0,
        auxiliaryRoomSolarHeatGain: 0,
        auxiliaryRoomHeatGeneration: 0,
        totalThermalLoad: 0,
        requiredCoolingCapacity: 0,
        safetyFactor: 0,
        totalRequiredCoolingCapacity: 0,
        mainRoomVolumetricFlow: 0,
        auxiliaryRoomVolumetricFlow: 0,
        auxiliaryRoomAverageTemperature: 0,
        expectedAirLeakage: 0,
        condensationAmount: 0,
        requiredDeviceCoolingCapacityForRoom: 0,
      },
      type: null,
    };
  },
  watch: {
    "$route.query": {
      handler() {
        this.SET_TYPE(this.$route.query.type || null);
      },
    },
  },
  methods: {
    SET_TYPE(type) {
      this.type = type;
      this.$router.push({
        query: {
          ...this.$route.query,
          type: type,
        },
      });
      if (type === "C1") {
        this.form.coolledAirRatio = 2;
        this.form.floorThickness3 = 0;
      }
      if (type === "C3") {
        this.form.coolledAirRatio = 45;
        this.form.floorThickness3 = 0;
      }
      if (type === "C2") {
        this.form.floorThickness3 = 200;
        this.form.coolledAirRatio = 2;
      }
    },
    VALIDATION_ERROR_MESSAGE(message) {
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: false,
        status: true,
        message: message,
        variant: "danger",
        duration: 2500,
      });
      return true;
    },
    validation() {
      this.validationActive = true;

      // Ambient Conditions validations
      if (this.form.altitudeLocation < 0 || !this.form.altitudeLocation) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.altitudeLocation") +
            " " +
            this.$t("common.cannotBeNegative")
        );
        return true;
      }
      if (this.form.ambientPressure < 0 || !this.form.ambientPressure) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.ambientPressure") +
            " " +
            this.$t("common.cannotBeNegative")
        );
        return true;
      }
      if (!this.form.ambientTemperature || this.form.ambientTemperature < 0) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.ambientTemperature") +
            " " +
            this.$t("common.required")
        );
        return true;
      }
      if (
        this.form.ambientRelativeHumidity < 0 ||
        this.form.ambientRelativeHumidity > 100
      ) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.ambientRelativeHumidity") +
            " " +
            this.$t("common.mustBeBetween", { min: 0, max: 100 })
        );
        return true;
      }
      if (
        this.form.solarRaditionPowerSquareMeter < 0 ||
        !this.form.solarRaditionPowerSquareMeter
      ) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.radiationPower") +
            " " +
            this.$t("common.cannotBeNegative")
        );
        return true;
      }

      // Geometric Parameters - Main Room validations
      if (this.form.length <= 0 || !this.form.length) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.length") +
            " " +
            this.$t("common.mustBePositive")
        );
        return true;
      }
      if (this.form.width <= 0 || !this.form.width) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.width") +
            " " +
            this.$t("common.mustBePositive")
        );
        return true;
      }
      if (this.form.heigth <= 0 || !this.form.heigth) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.height") +
            " " +
            this.$t("common.mustBePositive")
        );
        return true;
      }
      if (this.form.numberOfDoors < 0 || !this.form.numberOfDoors) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.numberOfDoors") +
            " " +
            this.$t("common.cannotBeNegative")
        );
        return true;
      }
      if (
        this.form.numberOfElectricalInletOutlet < 0 ||
        !this.form.numberOfElectricalInletOutlet
      ) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.electricalInletOutlet") +
            " " +
            this.$t("common.cannotBeNegative")
        );
        return true;
      }

      // Auxiliary Room validations
      if (this.form.lengthAuxiliary <= 0 || !this.form.lengthAuxiliary) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.auxiliaryRoom") +
            " " +
            this.$t("ehouseDoubleCalculating.length") +
            " " +
            this.$t("common.mustBePositive")
        );
        return true;
      }
      if (this.form.widthAuxiliary <= 0 || !this.form.widthAuxiliary) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.auxiliaryRoom") +
            " " +
            this.$t("ehouseDoubleCalculating.width") +
            " " +
            this.$t("common.mustBePositive")
        );
        return true;
      }
      if (this.form.heigthAuxiliary <= 0 || !this.form.heigthAuxiliary) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.auxiliaryRoom") +
            " " +
            this.$t("ehouseDoubleCalculating.height") +
            " " +
            this.$t("common.mustBePositive")
        );
        return true;
      }

      // Adjacent Wall validations
      if (this.form.adjecentWallLength <= 0 || !this.form.adjecentWallLength) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.adjecentWallLength") +
            " " +
            this.$t("common.mustBePositive")
        );
        return true;
      }
      if (this.form.adjecentWallHeigth <= 0 || !this.form.adjecentWallHeigth) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.adjecentWallHeigth") +
            " " +
            this.$t("common.mustBePositive")
        );
        return true;
      }

      // Air Conditions validations
      if (!this.form.airTemperature) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.airTemperature") +
            " " +
            this.$t("common.required")
        );
        return true;
      }
      if (
        this.form.airRelativeHumidity < 0 ||
        this.form.airRelativeHumidity > 100
      ) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.airRelativeHumidity") +
            " " +
            this.$t("common.mustBeBetween", { min: 0, max: 100 })
        );
        return true;
      }

      // Heat Generation validations
      if (this.form.heatGeneration < 0 || !this.form.heatGeneration) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.heatGeneration") +
            " " +
            this.$t("common.cannotBeNegative")
        );
        return true;
      }
      if (this.form.coolledAirRatio < 0 || !this.form.coolledAirRatio) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.coolledAirRatio") +
            " " +
            this.$t("common.cannotBeNegative")
        );
        return true;
      }
      if (
        this.form.auxiliaryHeatGeneration < 0 ||
        !this.form.auxiliaryHeatGeneration
      ) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.auxiliaryRoom") +
            " " +
            this.$t("ehouseDoubleCalculating.heatGeneration") +
            " " +
            this.$t("common.cannotBeNegative")
        );
        return true;
      }

      // Pressurization validations
      if (
        this.form.requiredPressurazing < 0 ||
        !this.form.requiredPressurazing
      ) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.requiredPressurization") +
            " " +
            this.$t("common.cannotBeNegative")
        );
        return true;
      }

      // Wall Material validations
      if (
        this.form.wallsThickness1 < 0 ||
        this.form.wallsThickness2 < 0 ||
        this.form.wallsThickness3 < 0 ||
        this.form.wallsThickness4 < 0 ||
        this.form.wallsThickness5 < 0
      ) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.wallsThickness") +
            " " +
            this.$t("common.cannotBeNegative")
        );
        return true;
      }

      // Floor Material validations
      if (
        this.form.floorThickness1 < 0 ||
        this.form.floorThickness2 < 0 ||
        this.form.floorThickness3 < 0 ||
        this.form.floorThickness4 < 0 ||
        this.form.floorThickness5 < 0
      ) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.floorThickness") +
            " " +
            this.$t("common.cannotBeNegative")
        );
        return true;
      }

      // Ceiling Material validations
      if (
        this.form.ceilingThickness1 < 0 ||
        this.form.ceilingThickness2 < 0 ||
        this.form.ceilingThickness3 < 0 ||
        this.form.ceilingThickness4 < 0 ||
        this.form.ceilingThickness5 < 0
      ) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.ceilingThickness") +
            " " +
            this.$t("common.cannotBeNegative")
        );
        return true;
      }
      console.log(this.form);

      // Adjacent Wall Material validations
      if (
        this.type !== "C1" &&
        (this.form.adjacentWallThickness1 < 0 ||
          this.form.adjacentWallThickness2 < 0 ||
          this.form.adjacentWallThickness3 < 0 ||
          this.form.adjacentWallThickness4 < 0 ||
          this.form.adjacentWallThickness5 < 0)
      ) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.adjacentWallMaterialValues") +
            " " +
            this.$t("common.cannotBeNegative")
        );
        return true;
      }

      // Material Thickness validations
      if (
        this.form.pvcThickness < 0 ||
        this.form.noneMaterialThickness < 0 ||
        this.form.steelPlateThickness < 0 ||
        this.form.asbestosThickness < 0
      ) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.materialThickness") +
            " " +
            this.$t("common.cannotBeNegative")
        );
        return true;
      }

      // Material Thermal Conductivity validations
      if (
        !this.form.pvcThermalConductivity ||
        !this.form.noneMaterialThermalConductivity ||
        !this.form.steelPlateThermalConductivity ||
        !this.form.asbestosThermalConductivity
      ) {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t("ehouseDoubleCalculating.thermalConductivity") +
            " " +
            this.$t("common.required")
        );
        return true;
      }

      // Mevcut validation kodu
      return false;
    },
    setForm() {
      return {
        altitudeLocation: this.form.altitudeLocation,
        ambientPressure: this.form.ambientPressure,
        ambientTemperature: this.form.ambientTemperature,
        ambientRelativeHumidity: this.form.ambientRelativeHumidity,
        solarRaditionPowerSquareMeter: this.form.solarRaditionPowerSquareMeter,
        length: this.form.length,
        width: this.form.width,
        heigth: this.form.heigth,
        numberOfDoors: this.form.numberOfDoors,
        numberOfElectricalInletOutlet: this.form.numberOfElectricalInletOutlet,
        lengthAuxiliary: this.form.lengthAuxiliary,
        widthAuxiliary: this.form.widthAuxiliary,
        heigthAuxiliary: this.form.heigthAuxiliary,
        adjecentWallLength: this.form.adjecentWallLength,
        adjecentWallHeigth: this.form.adjecentWallHeigth,
        overallHeatTransferCoefficientU: Number(
          this.form.overallHeatTransferCoefficientU
        ),
        airTemperature: this.form.airTemperature,
        airRelativeHumidity: this.form.airRelativeHumidity,
        heatGeneration: this.form.heatGeneration,
        coolledAirRatio: this.form.coolledAirRatio,
        auxiliaryHeatGeneration: this.form.auxiliaryHeatGeneration,
        requiredPressurazing: this.form.requiredPressurazing,
        pressurazingPressure: this.form.pressurazingPressure,
        wallsThickness1: this.form.wallsThickness1 || 0,
        wallsThickness2: this.form.wallsThickness2 || 0,
        wallsThickness3: this.form.wallsThickness3 || 0,
        wallsThickness4: this.form.wallsThickness4 || 0,
        wallsThickness5: this.form.wallsThickness5 || 0,
        wallsMaterialValues1: this.form.wallsMaterialValues1.value,
        wallsMaterialValues2: this.form.wallsMaterialValues2.value,
        wallsMaterialValues3: this.form.wallsMaterialValues3.value,
        wallsMaterialValues4: this.form.wallsMaterialValues4.value,
        wallsMaterialValues5: this.form.wallsMaterialValues5.value,
        floorF28: this.form.floorF28 || 1,
        floorOverallHeatTransferCoefficientU: Number(
          this.form.floorOverallHeatTransferCoefficientU
        ),
        floorThickness1: this.form.floorThickness1 || 0,
        floorThickness2: this.form.floorThickness2 || 0,
        floorThickness3: this.form.floorThickness3 || 0,
        floorThickness4: this.form.floorThickness4 || 0,
        floorThickness5: this.form.floorThickness5 || 0,
        floorMaterialValues1: this.form.floorMaterialValues1.value,
        floorMaterialValues2: this.form.floorMaterialValues2.value,
        floorMaterialValues3: this.form.floorMaterialValues3.value,
        floorMaterialValues4: this.form.floorMaterialValues4.value,
        floorMaterialValues5: this.form.floorMaterialValues5.value,
        ceilingOverallHeatTransferCoefficientU: Number(
          this.form.ceilingOverallHeatTransferCoefficientU
        ),
        ceilingThickness1: this.form.ceilingThickness1 || 0,
        ceilingThickness2: this.form.ceilingThickness2 || 0,
        ceilingThickness3: this.form.ceilingThickness3 || 0,
        ceilingThickness4: this.form.ceilingThickness4 || 0,
        ceilingThickness5: this.form.ceilingThickness5 || 0,
        ceilingMaterialValues1: this.form.ceilingMaterialValues1.value,
        ceilingMaterialValues2: this.form.ceilingMaterialValues2.value,
        ceilingMaterialValues3: this.form.ceilingMaterialValues3.value,
        ceilingMaterialValues4: this.form.ceilingMaterialValues4.value,
        ceilingMaterialValues5: this.form.ceilingMaterialValues5.value,
        adjacentWallThickness1: this.form.adjacentWallThickness1 || 0,
        adjacentWallThickness2: this.form.adjacentWallThickness2 || 0,
        adjacentWallThickness3: this.form.adjacentWallThickness3 || 0,
        adjacentWallThickness4: this.form.adjacentWallThickness4 || 0,
        adjacentWallThickness5: this.form.adjacentWallThickness5 || 0,
        adjacentWallOverallHeatTransferCoefficientU: Number(
          this.form.adjacentWallOverallHeatTransferCoefficientU
        ),
        adjacentWallMaterialValues1:
          this.form.adjacentWallMaterialValues1.value,
        adjacentWallMaterialValues2:
          this.form.adjacentWallMaterialValues2.value,
        adjacentWallMaterialValues3:
          this.form.adjacentWallMaterialValues3.value,
        adjacentWallMaterialValues4:
          this.form.adjacentWallMaterialValues4.value,
        adjacentWallMaterialValues5:
          this.form.adjacentWallMaterialValues5.value,
      };
    },
    async calculate(e, loading) {
      const validation = this.validation();
      if (validation) return;
      if (loading) loading(true);

      // Hesaplama işlemi
      const response = await this.getRequestCalculateUrl(this.setForm());
      if (response.message === "OK") {
        this.result = response.data;
        this.activeTab = "report";
      } else {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t(`message.${response.message}.description`)
        );
      }

      if (loading) loading(false);

      // Sonuç alanına otomatik kaydırma
    },
    async save(title, loading) {
      const validation = this.validation();
      if (validation) return;
      if (loading) loading(true);
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: true,
        status: true,
        duration: 20 * 60 * 1000,
      });
      // Hesaplama işlemi
      const response = await this.getRequestAddUrl(this.setForm(), title);
      if (response.message === "OK") {
        this.activeTab = "report";
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("common.saveSuccess"),
          variant: "success",
          duration: 2500,
        });
      } else {
        this.VALIDATION_ERROR_MESSAGE(
          this.$t(`message.${response.message}.description`)
        );
      }

      if (loading) loading(false);

      // Sonuç alanına otomatik kaydırma
    },
    getRequestCalculateUrl(form) {
      if (this.type === "C1") {
        return Requests.HeatGain.CalculateHeatGainDoubleRoomC1(form);
      } else if (this.type === "C2") {
        return Requests.HeatGain.CalculateHeatGainDoubleRoomC2(form);
      } else if (this.type === "C3") {
        return Requests.HeatGain.CalculateHeatGainDoubleRoomC3(form);
      }
    },
    getRequestAddUrl(form, title) {
      if (this.type === "C1") {
        return Requests.HeatGain.AddHeatGainDoubleRoomC1({
          ...form,
          title: title,
        });
      } else if (this.type === "C2") {
        return Requests.HeatGain.AddHeatGainDoubleRoomC2({
          ...form,
          title: title,
        });
      } else if (this.type === "C3") {
        return Requests.HeatGain.AddHeatGainDoubleRoomC3({
          ...form,
          title: title,
        });
      }
    },
  },
};
</script>

<style scoped>
.u-flex-1-with-child {
  flex: 1;
}
</style>
